import { z } from 'zod';
/**
 * Money value object — amount in minor units (cents) + ISO 4217 currency code.
 *
 * Storing amounts as integers in minor units avoids floating-point rounding
 * errors (Stripe, PSD2 accounting, etc. use the same convention).
 *
 *   EUR 49.00  →  { amountMinor: 4900, currency: 'EUR' }
 *   USD 0.99   →  { amountMinor: 99,   currency: 'USD' }
 *
 * For display, format via Intl.NumberFormat on the frontend:
 *   new Intl.NumberFormat('fr-FR', { style: 'currency', currency: m.currency })
 *     .format(m.amountMinor / 100)
 *
 * Supported currencies are constrained to the ones we actually bill in.
 * Extend as needed.
 */
export const SupportedCurrencySchema = z.enum(['EUR', 'USD', 'GBP']);
export const MoneySchema = z.object({
    amountMinor: z.number().int().nonnegative(),
    currency: SupportedCurrencySchema,
});
/**
 * Helper constructors. Kept in the shared package because both sides need
 * to build Money values consistently (frontend for display inputs, backend
 * for invoice lines).
 */
export function euros(amountInEuros) {
    return { amountMinor: Math.round(amountInEuros * 100), currency: 'EUR' };
}
export function dollars(amountInDollars) {
    return { amountMinor: Math.round(amountInDollars * 100), currency: 'USD' };
}
//# sourceMappingURL=money.schema.js.map